import React from 'react'
import { useFetch } from '../../../hooks/useFetch'
import { generateID } from '../../../modules/generator-id/generator-id'
import Spinner from '../../atoms/spinner/Spinner'
import TextTitle from '../../infoAboutMe/title-h3/TextTitle'
import Project from './project/Project'
import { DivWithBorder, ProjectContainer } from './styles'

const ProjectsArea = () => {

  const [response, error, loading] = useFetch("https://thawing-plains-55172.herokuapp.com/projects/")

  if (loading !== false) {
    return (
      <Spinner />
    )
  }

  if (error) {
    return (
      <p
        data-testid="calledApiError"
      >
        Sorry we are having trouble showing projects
      </p>
    )
  }

  return (
    <DivWithBorder>
      <div
        style={{
          display: 'flex',
        }}
      >
        <TextTitle 
          text="Projects "
          stylesElement={{
            fontSize: '1.8rem',
            marginTop: "20px",
            marginRigth: "10px",
            marginBottom: "20px",
            fontSize_lg: '3rem',
          }}
        />
          
        <TextTitle 
          text="</>"
          stylesElement={{
            fontSize: '1.8rem',
            marginTop: "20px",
            color: "#F7DF1E",
            marginBottom: "20px",
            fontSize_lg: '3rem',
          }}
        />

      </div>

      <ProjectContainer>
        
        {response.data.map(({ name, img, urlDemo, description, urlGitHub, technologies }) =>  
          <Project 
            name={name}
            urlImage={img}
            urlPage={urlDemo}
            description={description}
            urlGitHub={urlGitHub}
            technologies={technologies}
            key={generateID()}
          />
        )}

      </ProjectContainer>



    </DivWithBorder>
  )
}

export default ProjectsArea
